import { customFetch } from 'utils/http';
import { getM8AuthURL } from 'services/production/utils/getM8URL';
import { createQueryString } from 'services/production/utils/createQueryString';

type Params = {
  email: string;
};

export const isEmailPretty = async (params: Params): Promise<boolean> => {
  const fetchURL = getM8AuthURL(`isEmailPretty?${createQueryString(params)}`);

  const response = await customFetch(fetchURL);

  return response.json();
};
